import { StyledIcon } from 'src/components/foundations/foundations.styles';
import styled from 'styled-components';

export const TagTypeTitleStyled = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: center;
  overflow-x: hidden;
`;

export const StyledIconStyled = styled(StyledIcon)`
  padding: 10px 0;
`;
